var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSmTicket = function SvgIcSmTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 5.982V4.5c0-.642-.51-1.167-1.134-1.167H3.467c-.624 0-1.128.52-1.128 1.167v1.482c0 .402.187.799.533.986.357.204.595.589.595 1.032 0 .443-.244.834-.601 1.027-.34.192-.533.589-.533.991V11.5c0 .642.51 1.167 1.134 1.167h9.066c.624 0 1.134-.525 1.134-1.167v-1.482c0-.402-.193-.799-.533-.991a1.173 1.173 0 0 1-.6-1.027c0-.443.243-.828.6-1.027.34-.192.533-.589.533-.991Zm-5.1 4.66a.567.567 0 1 1-1.133 0v-.034a.567.567 0 0 1 1.133 0v.034Zm0-2.625a.567.567 0 0 1-1.133 0v-.034a.567.567 0 0 1 1.133 0v.034Zm0-2.625a.567.567 0 0 1-1.133 0v-.034a.567.567 0 0 1 1.133 0v.034Z",
    fill: "currentColor"
  })));
};
export default SvgIcSmTicket;